import { useMutation } from 'react-query';

import { getReport as getReportQueryFn } from 'api/endPoints/getReport';
import { setReport } from 'api/endPoints/setReport';

import { prepareReportPayloadForSetReportAPI } from 'components/Dashboards/Reporting/reporting.utils';

interface QueryResponse {
    id: number;
}

interface UseMutationChangeReportNameQueryParams {
    reportId: number;
    name: string;
}

export const UseMutationChangeReportName = () => {
    return useMutation<QueryResponse, QueryError, UseMutationChangeReportNameQueryParams>({
        mutationFn: async (params) => {
            const report = await getReportQueryFn({ id: params.reportId });
            const reportPayloadForSetReportApi = prepareReportPayloadForSetReportAPI(report);

            const reportPayloadWithUpdatedName = {
                ...reportPayloadForSetReportApi,
                name: params.name,
            };

            return setReport(reportPayloadWithUpdatedName);
        },
    });
};
